import apolloWrapper from '@hoc/apolloWrapper';
import { ComplaintModal } from '@components/ComplaintModal';

import {
  useComplaintModalQuery,
  useCreateComplaintMutation,
} from './queries/graphql.v3.generated';

type Props = {
  canComplain: boolean;
  allowComplain: (allow: boolean) => void,
  step: number,
  increaseStep: (counter: number) => void,
  complaintId: number | null,
  setComplaintId: (prevState: null) => void,
  userId: number,
  productId?: number,
};

export const ComplaintModalContainer: React.FC<Props> = ({
  canComplain,
  allowComplain,
  step,
  increaseStep,
  complaintId,
  setComplaintId,
  userId,
  productId,
}) => {
  const {
    loading, error, data, refetch,
  } = useComplaintModalQuery();

  const [createComplaint] = useCreateComplaintMutation();

  if (loading || error || !data || !data.complaintTypes) {
    return null;
  }

  return (
    <ComplaintModal
      types={data.complaintTypes.types}
      refetch={refetch}
      initial={canComplain}
      allowComplain={allowComplain}
      step={step}
      increaseStep={increaseStep}
      complaintId={complaintId}
      setComplaintId={setComplaintId}
      userId={userId}
      createComplaint={createComplaint}
      productId={productId}
      email={data.viewer.email}
    />
  );
};

export default apolloWrapper(ComplaintModalContainer);
